import { AnyAction } from "redux";
import { PptInterface } from "../types";
import { PptType } from "../../tournaments/types";

export const success = (
  state: PptInterface,
  action: AnyAction,
  key: PptType
): PptInterface => ({
  ...state,
  ppt: {
    ...state.ppt,
    [key]: {
      ...state.ppt[key],
      filter: action.payload.filter
    }
  },
  requestStates: {
    ...state.requestStates,
    [key]: {
      ...state.requestStates[key],
      filter: { failed: false, requesting: false, success: true }
    }
  }
});

export const requested = (state: PptInterface, key: PptType): PptInterface => ({
  ...state,
  requestStates: {
    ...state.requestStates,
    [key]: {
      ...state.requestStates[key],
      filter: { failed: false, requesting: true, success: false }
    }
  }
});

export const failed = (
  state: PptInterface,
  action: AnyAction,
  key: PptType
): PptInterface => ({
  ...state,
  requestStates: {
    ...state.requestStates,
    [key]: {
      ...state.requestStates[key],
      filter: { failed: action.error, requesting: false, success: false }
    }
  }
});

export const clear = (state: PptInterface, key: PptType): PptInterface => ({
  ...state,
  requestStates: {
    ...state.requestStates,
    [key]: {
      ...state.requestStates[key],
      filter: { failed: false, requesting: false, success: false }
    }
  }
});
